import { cn } from '../lib/utils';

const laneColors = {
  research: 'from-cyan-500 to-cyan-400',
  ugc: 'from-violet-500 to-violet-400',
  winning: 'from-emerald-500 to-emerald-400',
  ads: 'from-amber-500 to-amber-400',
  shopify: 'from-indigo-500 to-indigo-400',
  default: 'from-cyan-500 to-cyan-400'
};

const laneSolidColors = {
  research: 'bg-cyan-500',
  ugc: 'bg-violet-500',
  winning: 'bg-emerald-500',
  ads: 'bg-amber-500',
  shopify: 'bg-indigo-500',
  default: 'bg-cyan-500'
};

export function ProgressBar({ 
  value = 0, 
  lane = 'default', 
  size = 'md', 
  animated = false, 
  showValue = false,
  className 
}) {
  const sizeClasses = {
    sm: 'h-1.5',
    md: 'h-2.5',
    lg: 'h-3.5',
    xl: 'h-4'
  };

  const clampedValue = Math.min(100, Math.max(0, value));

  return (
    <div className={cn('flex items-center gap-3', className)} data-testid={`progress-bar-${lane}`}>
      <div 
        className={cn(
          'flex-1 bg-slate-200 rounded-full overflow-hidden',
          sizeClasses[size],
          animated && 'shadow-inner'
        )}
      >
        <div
          className={cn(
            'h-full rounded-full transition-all duration-700 ease-out relative overflow-hidden bg-gradient-to-r',
            laneColors[lane] || laneColors.default
          )}
          style={{ width: `${clampedValue}%` }}
        >
          {animated && clampedValue > 0 && (
            <div className="absolute inset-0 animate-shimmer" />
          )}
        </div>
      </div>
      {showValue && (
        <span className="text-xs font-semibold text-slate-600 min-w-[3rem] text-right">
          {clampedValue}%
        </span>
      )}
    </div>
  );
}

export function MiniProgressBar({ value = 0, lane = 'default', label }) {
  const clampedValue = Math.min(100, Math.max(0, value));

  return (
    <div className="flex items-center gap-2">
      {label && (
        <span className="text-xs font-medium text-slate-600 w-16 truncate">{label}</span>
      )}
      <div className="flex-1 bg-slate-200 rounded-full h-1.5 overflow-hidden">
        <div
          className={cn(
            'h-full rounded-full transition-all duration-500',
            laneSolidColors[lane] || laneSolidColors.default
          )}
          style={{ width: `${clampedValue}%` }}
        />
      </div>
      <span className="text-xs font-semibold text-slate-700 w-10 text-right">
        {clampedValue}%
      </span>
    </div>
  );
}
